/* eslint-disable curly */
import React from "react";
import { AppLayout } from "/lib/component/partial";
import { Content } from "/lib/component/base";
import { Box, Typography } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useRouter } from "../util";
import { parseStringParam } from "/lib/util/params";
import ReportConfigurationDialog from "../reports/ReportConfigurationDialog";
import { ReportTable } from "../reports/ReportTable";
import BlockedView from "../reports/BlockedView";

// Styles
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    marginTop: theme.spacing(5),
    width: "100%",
    margin: "auto",
  },
  header: {
    padding: theme.spacing(2.5),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  errorContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4),
  },
  errorMessage: {
    marginBottom: theme.spacing(2),
  },
}));

const DISABLED_NAMESPACE = [
  "bm-lfi",
  "catskill",
  "catskillOTB",
  "default",
  "factoryDefault",
  "sensu-system",
  "testing",
  "tuscon2023"
];

export const ReportsView: React.FC = () => {
  const router = useRouter();
  const classes = useStyles();
  const namespace = parseStringParam(
    (router.match.params as any).namespace,
    "",
  );
  const theme = useTheme();

  const isNamespaceDisabled = DISABLED_NAMESPACE.includes(namespace);

  return (
    <AppLayout>
      <Content marginBottom>
        <Box className={classes.root}>
          <div className={classes.header}>
            <Typography
              variant="h5"
              style={{ color: theme.palette.text.primary }}
            >
              Daily Report
            </Typography>
            <div>{!isNamespaceDisabled && <ReportConfigurationDialog />}</div>
          </div>
          {isNamespaceDisabled ? (
            <BlockedView />
          ) : (
            <ReportTable namespace={namespace} />
          )}
        </Box>
      </Content>
    </AppLayout>
  );
};

export default React.memo(ReportsView);
